import { type ChangeEvent, useRef } from 'react'

import { fileTypes } from 'commons/utils/file'
import { Icon, SlimButton } from 'components'

import * as S from './styles'

interface TopBarProps {
  onFileSelect: (event: ChangeEvent<HTMLInputElement>) => void
  onDownloadClick: () => void
  onTrackingClick: () => void
  disabled?: boolean
}

const ICON_SIZE = '16'

export const TopBar = ({
  onFileSelect,
  onDownloadClick,
  onTrackingClick,
  disabled = false,
}: TopBarProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null)
  const handleUploadClick = () => {
    if (fileInputRef.current !== null) {
      fileInputRef.current.click()
    }
  }

  return (
    <S.Container>
      <S.FileInput
        accept={fileTypes.Excel}
        data-testid="upload-input"
        onChange={onFileSelect}
        ref={fileInputRef}
        type="file"
      />
      <SlimButton
        content="Upload"
        data-testid="upload-button"
        disabled={disabled}
        icon={<Icon icon="upload" size={ICON_SIZE} />}
        onClick={handleUploadClick}
        variant="ghost"
      />
      <SlimButton
        content="Baixar"
        data-testid="download-button"
        disabled={disabled}
        icon={<Icon icon="download" size={ICON_SIZE} />}
        onClick={onDownloadClick}
        variant="ghost"
      />
      <SlimButton
        content="Tracking"
        data-testid="tracking-button"
        disabled={disabled}
        icon={<Icon icon="track" size={ICON_SIZE} />}
        onClick={onTrackingClick}
        variant="ghost"
      />
    </S.Container>
  )
}
